import { render, staticRenderFns } from "./EstatisticaLeilao.vue?vue&type=template&id=3d9964da"
import script from "./EstatisticaLeilao.vue?vue&type=script&lang=js"
export * from "./EstatisticaLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports